import { exitImpersonation, type Me } from "./session";

/** Shown whenever this session is an admin impersonating a customer (#261, ADR 0062). */
export function ImpersonationBanner({ me }: { me: Me }) {
  if (!me.impersonator) {
    return null;
  }

  return (
    <div className="impersonation-banner">
      Impersonating <strong>{me.name || me.email || me.sub}</strong>
      <button type="button" onClick={exitImpersonation}>
        Exit
      </button>
    </div>
  );
}
